document.addEventListener('DOMContentLoaded', function() {
  // Initialize filter functionality
  const initFilters = () => {
    try {
      // Initialize price range slider if noUiSlider is available
      if (typeof noUiSlider !== 'undefined') {
        const priceSlider = document.getElementById('price-slider');
        if (priceSlider) {
          noUiSlider.create(priceSlider, {
            start: [0, 100],
            connect: true,
            range: {
              'min': 0,
              'max': 100
            }
          });
        }
      }

      // Initialize filter accordion
      const filterAccordions = document.querySelectorAll('.filter-accordion');
      filterAccordions.forEach(accordion => {
        const header = accordion.querySelector('.filter-accordion-header');
        if (header) {
          header.addEventListener('click', () => {
            accordion.classList.toggle('active');
          });
        }
      });

      // Initialize filter drawer
      const filterDrawer = document.querySelector('.filter-drawer');
      const filterToggle = document.querySelector('.filter-toggle');
      const filterClose = document.querySelector('.filter-close');

      if (filterDrawer && filterToggle) {
        filterToggle.addEventListener('click', () => {
          filterDrawer.classList.add('active');
        });
      }

      if (filterDrawer && filterClose) {
        filterClose.addEventListener('click', () => {
          filterDrawer.classList.remove('active');
        });
      }

      // Handle filter form submission
      const filterForm = document.querySelector('.filter-form');
      if (filterForm) {
        filterForm.addEventListener('submit', (e) => {
          e.preventDefault();
          // Add your filter submission logic here
        });
      }

      // Remove loading state
      const loadingElement = document.querySelector('.filter-loading');
      if (loadingElement) {
        loadingElement.style.display = 'none';
      }

    } catch (error) {
      console.error('Error initializing filters:', error);
      // Remove loading state even if there's an error
      const loadingElement = document.querySelector('.filter-loading');
      if (loadingElement) {
        loadingElement.style.display = 'none';
      }
    }
  };

  // Wait for jQuery and Adnabu to be available
  const waitForDependencies = setInterval(() => {
    if (window.jQuery && window.adnabuEventSubscriber) {
      clearInterval(waitForDependencies);
      initFilters();
    }
  }, 100);

  // Fallback in case dependencies don't load
  setTimeout(() => {
    if (!window.jQuery || !window.adnabuEventSubscriber) {
      console.warn('Some dependencies not loaded, initializing filters anyway');
      initFilters();
    }
  }, 5000);
}); 